import React from 'react';
import { Table, Button, Input, message, DatePicker } from 'antd';

class OperationLogStatistics extends React.Component {
    constructor() {
        super();
        tool.setLoginInfoExtra({
            "pageSize": 10,
            "offset": 1
        })
        this.SrvMonitorSrvStatQuery();//调用查询操作日志统计数据服务

        this.state = {
            listData: [],//表数据
            srvSrlno: "",//查询条件-服务标示
            pagination: {
                total: 0,
                pageSize: 0,
            },
        }
    }
    //查询操作日志统计数据服务
    SrvMonitorSrvStatQuery(body) {
        let req = body || {}
        var success = function (res) {
            if (res && res.head.code == "0000") {
                tool.sgiLogger.info(res);

                this.setState({
                    listData: res.body,
                    pagination: {
                        total: res.head.pageCount,
                        pageSize: res.head.recordCount,
                    },
                })
            } else {
                message.error(res.head.msg)
            }
        };
        commonClient.simplecall(sgiConfig.allUrl.SrvMonitorSrvStatQuery, req, success.bind(this), true);
    }
    //查询条件-开始时间
    startTimeChange(value, dateString) {
        tool.sgiLogger.info('Selected Time: ', value);
        tool.sgiLogger.info('Formatted Selected Time: ', dateString);
        this.setState({
            startTime: dateString
        })
    }
    //查询条件-结束时间
    endTimeChange(value, dateString) {
        tool.sgiLogger.info('Selected Time: ', value);
        tool.sgiLogger.info('Formatted Selected Time: ', dateString);
        this.setState({
            endTime: dateString
        })
    }
    //点击条件查询按钮
    searchClick() {
        if (this.state.startTime && this.state.endTime && this.state.startTime > this.state.endTime) {
            message.error("结束时间不能早于开始时间！");
            return
        }

        let req = {
            startTime: this.state.startTime,
            endTime: this.state.endTime,
        }
        tool.sgiLogger.info(req);
        this.SrvMonitorSrvStatQuery(req);
    }

    //表格换页
    handleTableChange(pagination, filters, sorter) {
        tool.sgiLogger.info(pagination, filters, sorter)
        tool.setLoginInfoExtra({
            "pageSize": 10,
            "offset": pagination.current
        })
        let req = {
            startTime: this.state.startTime,
            endTime: this.state.endTime,
        }
        tool.sgiLogger.info(req);
        this.SrvMonitorSrvStatQuery(req);
    }
    render() {
        const columns = [
            {
                title: "服务标示",
                dataIndex: "srvSrlno"
            },
            {
                title: "平均耗时",
                dataIndex: "avgTimcnsm"
            },
            {
                title: "最大耗时",
                dataIndex: "maxTimcnsm"
            },
            {
                title: "最小耗时",
                dataIndex: "minTimcnsm"
            },
            {
                title: "操作总数",
                dataIndex: "sum"
            },
            {
                title: "成功数",
                dataIndex: "sucNum"
            },
            {
                title: "失败数",
                dataIndex: "errNum"
            }
        ]
        return (
            <div>
                <div style={{ margin: '20px' }}>
                    <DatePicker
                        style={{ width: 200, marginLeft: "10px", marginBottom: "10px" }}
                        showTime
                        format="YYYY-MM-DD HH:mm:ss"
                        placeholder="开始时间"
                        onChange={this.startTimeChange.bind(this)}
                    />
                    <DatePicker
                        style={{ width: 200, marginLeft: "10px", marginBottom: "10px" }}
                        showTime
                        format="YYYY-MM-DD HH:mm:ss"
                        placeholder="结束时间"
                        onChange={this.endTimeChange.bind(this)}
                    />
                    <Button type={"primary"} icon={"search"} style={{ width: 80, marginLeft: "10px", marginBottom: "10px" }} onClick={this.searchClick.bind(this)}>查询</Button>
                </div>
                <Table pagination={this.state.pagination} columns={columns} onChange={this.handleTableChange.bind(this)} dataSource={this.state.listData} />
            </div>
        )
    }
}

export default OperationLogStatistics


// WEBPACK FOOTER //
// ./apps/pages/tranLog/OperationLogStatistics.js